import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import { Shuffle } from "@mui/icons-material";

const RandomizerNode = memo(({ id, data, isConnectable, selected }) => {
  const pctA = data?.percent ?? data?.percentA ?? 50;
  const pctB = 100 - pctA;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Shuffle />}
      title="Randomizador"
      color="#1FBADC"
      bgColor="#F8FCFD"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={210}
    >
      {/* Visual bar */}
      <div
        style={{
          display: "flex",
          borderRadius: 6,
          overflow: "hidden",
          height: 22,
          marginBottom: 8,
          border: "1px solid #B2EBF2",
        }}
      >
        <div style={{
          width: `${pctA}%`, background: "#1FBADC",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 10, fontWeight: 700, color: "#fff", minWidth: 28,
        }}>
          {pctA}%
        </div>
        <div style={{
          width: `${pctB}%`, background: "#0E8FAA",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 10, fontWeight: 700, color: "#fff", minWidth: 28,
        }}>
          {pctB}%
        </div>
      </div>

      {/* Handle rows at node edge */}
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{ fontSize: 10, color: "#666" }}>Caminho A</span>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#1FBADC", borderRadius: 4, padding: "2px 8px",
          }}>
            {pctA}%
          </span>
          <Handle
            type="source" position={Position.Right} id="a"
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              background: "#1FBADC", width: 14, height: 14,
              border: "2px solid #F8FCFD", borderRadius: "50%", cursor: "crosshair",
            }}
            isConnectable={isConnectable}
          />
        </div>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{ fontSize: 10, color: "#666" }}>Caminho B</span>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#0E8FAA", borderRadius: 4, padding: "2px 8px",
          }}>
            {pctB}%
          </span>
          <Handle
            type="source" position={Position.Right} id="b"
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              background: "#0E8FAA", width: 14, height: 14,
              border: "2px solid #F8FCFD", borderRadius: "50%", cursor: "crosshair",
            }}
            isConnectable={isConnectable}
          />
        </div>
      </div>
    </NodeWrapper>
  );
});

RandomizerNode.displayName = "RandomizerNode";
export default RandomizerNode;
